import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HpCatalogEmbed from "@/pages/home/components/HpCatalogEmbed";
import StrategicPartners from "@/pages/home/components/StrategicPartners";
import CTASection from "@/pages/home/components/CTASection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Projelerimiz() {
  return (
    <main className="bg-[#F8FAFC]">
      <Navbar />
      <HpCatalogEmbed />
      <StrategicPartners />
      <CTASection />
      <ContactSection />
      <Footer />
    </main>
  );
}
